import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/store";
import {$projectPaths} from "./navigation";

Vue.use(VueRouter);

export const routes = [
    {
        path: "/",
        redirect: "/login"
    },
    {
        path: "/login",
        component: require("./pages/auth/Login.vue").default,
        name: "login",
        meta: {
            guest: true
        }
    },
    {
        path: "/auth/:provider/callback",
        component: require("./pages/auth/AuthCallBack.vue").default,
        name: "login",
        meta: {
            guest: true
        }
    },
    {
        path: "/password",
        name: "password",
        component: require("./pages/auth/PasswordReminder.vue").default,
        meta: {
            guest: true
        }
    },
    {
        path: "/password/reset",
        component: require("./pages/auth/PasswordReset.vue").default,
        meta: {
            guest: true
        }
    },
    {
        path: "/register",
        component: require("./pages/auth/DeveloperSignUp.vue").default,
        name: "signup",
        meta: {
            guest: true
        }
    },
    {
        path: "/dashboard",
        component: require("./pages/dashboard/Splash").default,
        props: $projectPaths,
        children: [
            {
                path: "",
                component: require("./pages/dashboard/Landing").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/projects/create",
                component: require("./pages/projects/CreateProject").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/projects/:project/edit",
                name: "project-edit",
                component: require("./pages/projects/EditProject").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/users/profile",
                name: "user.profile",
                component: require("./pages/users/Profile").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/users/profile/edit",
                component: require("./pages/users/ProfileEdit").default,
                name: "users.edit",
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/users/apps/create",
                component: require("./pages/apps/CreateApiApp").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/users/apps/details/:clientId",
                component: require("./pages/apps/AppDetails").default,
                meta: {
                    requiresAuth: true
                }
            }]
    },
    {
        path: "/projects",
        component: require("./pages/dashboard/Splash").default,
        props: $projectPaths,
        meta: {
            requiresAuth: true
        },

        children: [
            {
                path: ":project/overview",
                name: "project",
                component: require("./pages/projects/ProjectDashboard").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/settings/apps",
                name: "project-settings.apps",
                component: require("./pages/projects/settings/dashboard").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/sms/express/send",
                component: require("./pages/sms/SendMessage").default,
                meta: {
                    requiresAuth: true
                }
            },

            {
                path: ":project/sms/bulk/send",
                component: require("./pages/sms/SendBulkMessage").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/sms/custom/upload-file",
                component: require("./pages/sms/UploadCustomBulkFile").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/sms/custom/compose",
                component: require("./pages/sms/ComposeCustomBulkMessage").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/sms/subscription/send",
                component: require("./pages/sms/SchedulePremiumMessage").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/sms/bulk-outbox",
                component: require("./pages/sms/Alerts").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/sms/outbox/:message",
                component: require("./pages/sms/MessageVIew").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/sms/api-outbox",
                component: require("./pages/sms/BulkOutbox").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/sms/inbox",
                name: "projects.sms.inbox.all",
                component: require("./pages/sms/SmsInbox").default,
                meta: {
                    requiresAuth: true
                }
            },

            {
                path: ":project/sms/short-codes",
                component: require("./pages/sms/SenderCodes").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/utility-bills/transactions",
                component: require("./pages/utility-bills/ListTransactions").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/contacts",
                component: require("./pages/contacts/ContactList").default,
                name: "project.contacts",
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/airtime/transactions",
                component: require("./pages/airtime/AirtimeTransactions").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/pg/transactions",
                component: require("./pages/pg/PGTransactions").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/pg/settings/keys",
                component: require("./pages/pg/PGSettings").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/pg/settings/mpesa",
                component: require("./pages/pg/MPESASettings").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/pg/settings/callback",
                component: require("./pages/pg/CallbackSettings").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/senti/salary_advance/get_requests",
                component: require("./pages/senti/SalaryAdvanceRequests").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/senti/salary_advance/register_employee",
                component: require("./pages/senti/CreateSalaryAdvanceEmployee").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/senti/salary_advance/get_employees",
                component: require("./pages/senti/SalaryAdvanceEmployees").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/senti/salary_advance/dashboard",
                component: require("./pages/senti/SalaryAdvanceDashboard").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/chats/webchat",
                component: require("./pages/chats/webchat/index").default,
                meta: {
                    requiresAuth: false
                }
            },

            {
                path: ":project/onboarding/chat",
                name: 'onboarding-chat',
                component: require("./pages/projects/onboarding/chats/index").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":project/onboarding/bulk-sms",
                name: 'onboarding-bulk-sms',
                component: require("./pages/projects/onboarding/sms/index").default,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ':project/sms/reports/exports',
                component: require('./pages/sms/ExportedReports').default,
                meta: {
                    requiresAuth: true
                },
            }

        ]
    },
    {
        path: "/apis",
        component: require("./pages/dashboard/Splash").default,
        props: $projectPaths,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "",
                component: require("./pages/products/ProductsDashboard").default,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: "create",
                component: require("./pages/products/CreateApiProduct").default,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: "apps/create",
                component: require("./pages/apps/CreateApiApp").default,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: "apps/details/:clientId",
                component: require("./pages/apps/AppDetails").default,
                meta: {
                    requireAuth: true
                }
            }
        ]
    },
    {
        path: "/services",
        component: require("./pages/dashboard/Splash").default,
        props: $projectPaths,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "short-codes/create",
                component: require("./pages/settings/OnBoardSenderCode").default,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: "short-codes",
                component: require("./pages/settings/Shortcodes").default,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: "my-short-codes",
                component: require("./pages/settings/UserShortCodes").default,
                meta: {
                    requireAuth: true
                }
            }
        ]
    },
    {
        path: "/accounts",
        component: require("./pages/dashboard/Splash").default,
        props: $projectPaths,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "billing",
                component: require("./pages/billing/MainOverview").default,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: ":account/overview",
                component: require("./pages/billing/pages/AccountView").default,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: ":account/add-funds",
                name: "account.payments.create",
                component: require("./pages/billing/pages/AccountTopUp").default,
                meta: {
                    requireAuth: true
                }
            }
        ]
    },
    {
        path: "*",
        component: require("./pages/errors/NotFound").default
    }
]


const router = new VueRouter({
    mode: "history",
    linkActiveClass: "active",
    routes: routes
});

router.beforeEach((to, from, next) => {
    store.dispatch("getToken");
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.isAuthenticated) {
            next({
                path: "/login",
                query: {redirect: to.fullPath}
            });
        }
    }
    // Redirect If Authenticated middleware
    // if (to.matched.some(record => record.meta.permissions)) {
    //     let userPerms = store.getters.authenticatedUser.permissions;
    //     if (userPerms) {
    //         _.includes(userPerms, record.meta.permissions);
    //         next({
    //             path: '/403'
    //         })
    //     }
    // }
    // if (to.matched.some(record => record.meta.roles)) {
    //     let roles = store.getters.authenticatedUser.roles;
    //     if (roles && roles.length) {
    //         _.includes(roles, record.meta.permissions);
    //         next({
    //             path: '/403'
    //         })
    //     }
    // }
    // Redirect If Authenticated middleware
    if (to.matched.some(record => record.meta.guest)) {
        if (store.getters.isAuthenticated) {
            next({
                path: "/dashboard"
            });
        }
    }
    next(); // make sure to always call next()!
});

export {router};
